import { render, staticRenderFns } from "./LoginForm.vue?vue&type=template&id=609bb06c&"
import script from "./LoginForm.vue?vue&type=script&lang=js&"
export * from "./LoginForm.vue?vue&type=script&lang=js&"
import style0 from "./LoginForm.vue?vue&type=style&index=0&id=609bb06c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputField: require('/vercel/path0/components/forms/InputField.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
